// extracted by mini-css-extract-plugin
module.exports = {"notification":"styles_notification__2f0qw","button":"styles_button__2nfGG","content":"styles_content__uxkS9"};